export enum UserEventsTypes {
  activated='APJ',
  clicked='APL',
  viewed='APK',
}
